// We support both new way and old way
// (we used to inject embed flag in kibanaRoute instead of embed=true/false in query string)
export const appEmbedded =
  window.location.href.indexOf('embed=true') > 0 ||
  window.location.href.substr(window.location.href.indexOf('kibanaRoute')).indexOf('%3Fembed') > 0;
